namespace $.$$ {
	export class $shm_hitalama_skills_item extends $.$shm_hitalama_skills_item {
		title() { return this.entry().title() }
		skill_id() { return this.entry().name() }
		link_arg() { return { skill: this.entry().link().str, help: 'off' } }
		content() { return this.renaming() ? [ this.Input() ] : [ this.entry().group() ? this.Menu() : this.Link() ] }
		anchor_content() { return [ this.entry().group() ? this.Group() : this.Link() ] }
		menu_content() { return this.entry().group() && this.catalog().can_change() ? [ this.Rename(), this.Add_skill(), this.Add_group(), this.Delete() ] : [] }
		delete_title() { return this.entry().group() ? 'Удалить группу' : 'Удалить скилл' }
		delete_question() { return this.entry().group() ? 'Удалить?' : 'Удалить скилл из каталога?' }
		@ $mol_mem
		renaming( next = false ) { return next }
		@ $mol_mem
		draft( next?: string ) { return next ?? this.title() }
		@ $mol_action
		contextmenu( event?: MouseEvent ) { if( event ) { event.preventDefault(); event.stopPropagation(); this.Menu().showed( true ) } return null }
		@ $mol_action
		rename_start( event?: Event ) {
			if( !event || !this.catalog().can_change() ) return null
			event.preventDefault(); event.stopPropagation()
			this.Menu().showed( false )
			this.draft( this.title() ); this.renaming( true )
			new this.$.$mol_after_frame( ()=> { this.Input().focused( true ); this.Input().selection([ 0, this.draft().length ]) } )
			return null
		}
		@ $mol_action
		rename_submit( event?: Event ) {
			if( event && this.renaming() ) {
				if( this.draft().trim() ) this.entry().title( this.draft().trim() )
				this.renaming( false )
			}
			return null
		}
		@ $mol_action
		rename_keydown( event?: KeyboardEvent ) { if( event?.key === 'Escape' ) { event.preventDefault(); event.stopPropagation(); this.renaming( false ) } return null }
		@ $mol_action
		input_pointerdown( event?: Event ) { event?.stopPropagation(); return null }
		@ $mol_action
		remove( event?: Event ) {
			if( !event ) return null
			const id = this.entry().link().str
			$mol_wire_sync( this.catalog() ).remove( id )
			this.Menu().showed( false )
			if( this.$.$mol_state_arg.value( 'skill' ) === id ) this.$.$mol_state_arg.value( 'skill', null )
			return null
		}
	}
}
